document.addEventListener('DOMContentLoaded', () => {
	initFeaturesSlider();
});

const initFeaturesSlider = () => {
	const sections = document.querySelectorAll('.js-features-slider');

	if (!sections.length) return;

	sections.forEach(section => {
		const sliderEl = section.querySelector('.js-features-slider-track');
		const prevBtn  = section.querySelector('.js-features-prev');
		const nextBtn  = section.querySelector('.js-features-next');

		if (!sliderEl) return;

		const splide = new Splide(sliderEl, {
			type: 'slide',
			perPage: 3,
			gap: 24,
			arrows: false,
			pagination: false,
			rewind: false,
			breakpoints: {
				1024: {
					perPage: 2,
					gap: 24,
					padding: { right: '40px' },
				},
				768: {
					perPage: 1,
				},
			},
		});

		if (prevBtn) {
			prevBtn.addEventListener('click', () => splide.go('<'));
		}

		if (nextBtn) {
			nextBtn.addEventListener('click', () => splide.go('>'));
		}

		splide.on('move', () => {
			const index = splide.index;
			const last  = splide.length - splide.options.perPage;

			if (prevBtn) prevBtn.classList.toggle('is-disabled', index === 0);
			if (nextBtn) nextBtn.classList.toggle('is-disabled', index >= last);
		});

		const equalizeCardHeights = () => {
			const cards = sliderEl.querySelectorAll('.features-slider__card');
			if (cards.length <= 1) return;

			cards.forEach(card => {
				card.style.minHeight = 'auto';
			});

			let maxHeight = 0;
			cards.forEach(card => {
				maxHeight = Math.max(maxHeight, card.offsetHeight);
			});

			cards.forEach(card => {
				card.style.minHeight = maxHeight + 'px';
			});
		};

		splide.on('mounted', () => {
			equalizeCardHeights();
		});

		splide.mount();

		if (prevBtn) prevBtn.classList.add('is-disabled');

		window.addEventListener('resize', () => {
			equalizeCardHeights();
		});
	});
};
